import { pageLanguage } from "../util/common";

// [BRYAN] - Swiper se incluso nel main.js da problemi
// import Swiper from 'swiper/dist/js/swiper.min'

// $(window).load(function() {
//   // [BRYAN] - Swiper su Sage va solo su window Load

//   new Swiper('.swiper-container', {
//     loop: true,
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     effect: 'fade',
//     speed: 1200,
//   });

// });

$(document).ready(function() {
	// [BRYAN] - Inserire JS autocaticato
	$(document).on('hover','.flip-hover', function() {

		$(this).toggleClass('round');
 
	});

	$(document).on('touchstart','.flip-hover', function() {

		$(this).toggleClass('round');
 
	});


	// PAGINA AGENTI
	$(".header-form input[type=file]").each(function(){
		var fileinput_id = $(this).attr('id');

		var label = pageLanguage() == 'en' ? "Choose file..." : "Scegli file...";

		var prepend = '<div class="fileinput" inputid="'+fileinput_id+'">'+label+'</div>';
		prepend += '<div class="fileinput-name" id="fn-'+fileinput_id+'"></div>';
		$(this).parent().prepend(prepend);
	});

	$('.header-form input[type="file"]').change(function(e){
		var fileName = e.target.files[0].name;
		var id = $(this).attr('id');

		$('#fn-'+id).text(fileName);
	});

	$('.header-form .fileinput').click(function(e){
		var inputid = $(this).attr('inputid');
		$('#'+inputid).trigger('click'); 
	});

	$(".header-form .fileinput-name").each(function(){
		var inputprev = $(this).parent().find('.ginput_preview');
		var inputprevtext = $(this).parent().find('.ginput_preview strong').text();
		if($(this).text() == '' && inputprev.length == 0) {
			var label = pageLanguage() == 'en' ? "no file selected" : "nessun file selezionato";
			$(this).text(label);
		} else {
			$(this).text(inputprevtext);
		}
	});

	$(".agenti .btn").not( ".not-scroll" ).click(function(e){
		e.preventDefault();

		if( $(this).attr('scrollto') != '' ){
			var scrollTo = $('.header-form');
			
			$('html, body').animate({
			    scrollTop: (scrollTo.offset().top)
			},600);
		}			
	});
	// FINE PAGINA AGENTI


});



// WEBPACK FOOTER //
// ./scripts/autoload/_pages.js